import React from 'react';
import PropTypes from 'prop-types';

import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";

import {Tooltip} from "@mui/material";
import {Edit} from "@mui/icons-material";

import {primaryColor} from "assets/jss/main";

import {MarketplaceRoutes} from "utils/MarketplaceRoutes";

EditFeedButton.propTypes = {
    feed: PropTypes.shape({
        '@id': PropTypes.string.isRequired,
        dataType: PropTypes.string.isRequired,
        transportType: PropTypes.string.isRequired,
    }).isRequired,
};

function EditFeedButton({feed}) {
    let feedType = feed.dataType + '-' + feed.transportType;

    if (feed.transportType === 'api') {
        feedType = 'api';
    }

    return (
        <Link to={MarketplaceRoutes.RETAILER_FEED_EDIT(feedType, feed['@id'])} onClick={(e) => e.stopPropagation()}>
            <Tooltip
                title={<FormattedMessage
                    id={"feed.list.table.tooltip.edit"}/>}>
                <Edit style={{color: primaryColor, cursor: "pointer"}}/>
            </Tooltip>
        </Link>
    );
}

export default EditFeedButton;
